module.exports = __webpack_public_path__ + "media/swimming_pool.cee4d66e.mp4";